<template>
  <a-modal
    class="template-copy-modal"
    :title="$t('TP_Copy_1')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("TP_Copy_2")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-group">
      <div class="content-item">
        <div class="modal-title">{{ $t("TP_Copy_4") }}</div>
        <div class="modal-value">
          <div class="selected-templates">
            <span v-for="(templateNo, index) in selectedNoArray" :key="templateNo" class="template-tag">
              {{ templateNo }}<span v-if="index < selectedNoArray.length - 1">, </span>
            </span>
            <span v-if="selectedNoArray.length === 0" class="no-selection">{{ $t("TP_Copy_5") }}</span>
          </div>
        </div>
      </div>
      
      <InputComponent
        customClass="user-input"
        type="text"
        :title="$t('User No')"
        moduleName="template"
        name="userNo"
        :value="userNo"
        :validation="['required', 'number']"
        @input="clearErrorMessage"
      />
      <!-- 서버 검증 에러 메시지 표시 -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </a-modal>
</template>

<script>
import { toRefs, ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import axios from "axios";
import InputComponent from "@/components/commonComponents/InputComponent";
import { apiUrl } from "@/utils/common";

export default {
  name: "TemplateCopyModal",
  props: {
    mode: String,
    visible: Boolean,
    templateInfo: Object,
    toggleModal: Function,
  },
  components: {
    InputComponent,
  },
  setup(props, { emit }) {
    const store = useStore();
    const { t } = useI18n();
    const templateState = computed(() => store.getters["template/STATE"]);
    const inputValues = computed(() => store.getters["template/GET_INPUT_VALUES"]);
    const selectedNoArray = computed(() => store.state.template?.selectedNoArray || []);
    const userNo = computed(() => inputValues.value.userNo || "");

    const state = reactive({
      loading: false,
      showWarning: false,
      errorMessage: "",
    });

    const handleOk = async () => {
      state.loading = true;
      state.errorMessage = ""; // 오류 메시지 초기화

      const params = {
        userNo: userNo.value,
        templateNoArray: selectedNoArray.value,
      };

      if (!!userNo.value) {
        try {
          const response = await axios.post(
            apiUrl + "Template/Copy",
            params,
          );
          // console.log("template copy response OK");

          if (response && !response.data.error) {
            // 복사 성공 후 부모 컴포넌트에 이벤트 emit
            emit('copy-success');
            props.toggleModal();
          } else {
            // 서버에서 반환한 오류 메시지 표시
            const errorInfo = response.data.error?.[0]?.errInfo || "Template copy error.";
            if (errorInfo === 'No user no') {
              state.errorMessage = t("TP_Copy_6");
            }
            else {
              state.errorMessage = errorInfo;
            }
          }
        } catch (error) {
          console.log("template copy error catch");
          // 네트워크 오류 또는 기타 오류 처리
          // state.errorMessage = "서버 연결 오류가 발생했습니다. 다시 시도해주세요.";
        }
      } else {
        state.errorMessage = "Need User No.";
      }

      state.loading = false;
    };

    const handleCancel = () => {
      props.toggleModal();
    };

    const clearErrorMessage = () => {
      state.errorMessage = "";
    };



    return {
      ...toRefs(state),
      selectedNoArray,
      userNo,
      handleOk,
      handleCancel,
      clearErrorMessage,
    };
  },
};
</script>

<style scoped>
.warning-message {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  padding-left: 4px;
}

.error-message {
  color: #ff4d4f;
  font-size: 13px;
  font-weight: 500;
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  border-left: 4px solid #ff4d4f;
}

.selected-templates {
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px 12px;
  min-height: 32px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

/* .template-tag {
  background-color: #1890ff;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
} */

.no-selection {
  color: #999;
  font-style: italic;
  font-size: 14px;
}
</style>